import { render, staticRenderFns } from "./BlocksLayout.vue?vue&type=template&id=6b77ad01&scoped=true&"
import script from "./BlocksLayout.vue?vue&type=script&lang=js&"
export * from "./BlocksLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b77ad01",
  null
  
)

export default component.exports